import Tab from 'components/tabs/tabs'
import React from 'react'
import Applications from 'assets/images/svg/applications_dark (1).svg'
import Addons from 'assets/images/svg/addons_dark.svg'
import { useTranslation } from 'react-i18next'
const WishlistTabs = () => {
  const {t} = useTranslation("browse-apps")
  return (
    <div className="tabs">
    <div className="nav">
        <Tab url=".." title={t('applications')} img={Applications} end />
        <Tab url="../addons" title={t('addons')} img={Addons} end />
    </div>
</div>
  )
}

export default WishlistTabs